import { Box } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-premium'

interface NumberCellProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  densityStyles: DensityStyleTypes
}

const NumberCell: FC<NumberCellProps> = ({ params, densityStyles }) => {
  const { org_uuid: _org_uuid, isParent } = params?.row ?? {}
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {/* {isOrganizationLoading ? <CircularProgress size={22} /> : isParent ? <Box>{Number(params.value)}</Box> : '–'} */}
      {isParent ? <Box>{Number(params.value)}</Box> : '–'}
    </Box>
  )
}
export default NumberCell
